/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{53981429-D850-4CB5-A81A-9B11727A6E2B}",
  "sitecoreApiHost": "https://ireland.upmc.local",
  "graphQLApiHost": "http://cm",
  "clientGraphQLApiHost": "https://ireland.upmc.local",
  "jssAppName": "ireland",
  "coveoAccessToken": "COVEO_SEARCH_API_KEY",
  "coveoOrganizationId": "COVEO_ORGANIZATIONID",
  "coveoPlatformUrl": "https://COVEO_ORGANIZATIONID.org.coveo.com",
  "coveoFarmName": "COVEO_FARM_NAME",
  "coveoSearchHub": "COVEO_SEARCH_HUB",
  "coveoQueryPipeline": "COVEO_QUERY_PIPELINE",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/ireland",
  "clientGraphQLEndpointPath": null,
  "graphQLEndpoint": "http://cm/api/ireland?sc_apikey={53981429-D850-4CB5-A81A-9B11727A6E2B}",
  "clientGraphQLEndpoint": "https://ireland.upmc.local/api/ireland?sc_apikey={53981429-D850-4CB5-A81A-9B11727A6E2B}"
};